export default {
    // Private variable to track the last search query
    _lastSearchQuery: '',
    
    init() {
        const $this = this;
        const triggers = document.querySelectorAll('.js-site-search-trigger');

        const isVisible = elem => !!elem && !!( elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length );

        triggers.forEach(trigger => {
            const parent = trigger.closest(".js-site-search");

            trigger.addEventListener("click", event => {
                parent.classList.toggle("is-open");

                trigger.setAttribute("aria-expanded", 
                    trigger.getAttribute("aria-expanded") === "true" ? "false" : "true"
                );

                const outsideClickListener = event => {
                    if (!parent.contains(event.target) && isVisible(parent)) {
                        parent.classList.toggle("is-open");
                        trigger.setAttribute("aria-expanded", 
                            trigger.getAttribute("aria-expanded") === "true" ? "false" : "true"
                        );
                        removeClickListener()
                    }
                };

                const removeClickListener = () => {
                    document.removeEventListener('click', outsideClickListener)
                };

                document.addEventListener('click', outsideClickListener);

                event.preventDefault();
            });
        });

        // Improved debounce utility function
        function debounce(func, delay) {
            let timeoutId;
            let lastExecutedTime = 0;
            
            return function() {
                const context = this;
                const args = arguments;
                const currentTime = Date.now();
                
                // Clear any existing timeout
                if (timeoutId) {
                    clearTimeout(timeoutId);
                }
                
                // If enough time has passed since last execution, execute immediately
                if (currentTime - lastExecutedTime > delay) {
                    lastExecutedTime = currentTime;
                    func.apply(context, args);
                } else {
                    // Otherwise, set a new timeout
                    timeoutId = setTimeout(() => {
                        lastExecutedTime = Date.now();
                        func.apply(context, args);
                    }, delay);
                }
            };
        }

        const inputs = document.querySelectorAll('.js-site-search-input');

        inputs.forEach(input => {
            // Create a debounced version of the search function
            const debouncedSearch = debounce(function() {
                let val = input.value.trim();
                $this.search(val);
            }, 300); // 300ms delay, adjust as needed
        
            // Add event listener with debounced function
            input.addEventListener('keyup', debouncedSearch);
        });
    },

    search(val) {
        let searchResults = document.querySelector('.js-site-search-results');
        let searchInput = document.querySelector('.js-site-search-input');

        // Prevent duplicate or unnecessary searches
        if (val.length < 3 || val === this._lastSearchQuery) {
            // If search query is too short or same as last search, clear results
            searchResults.innerHTML = '';
            searchResults.classList.remove('is-open');
            return;
        }

        // Update last search query
        this._lastSearchQuery = val;

        // Clear previous results
        searchResults.innerHTML = '';

        // Show loader
        searchInput.classList.add('is-loading');

        axios.get(`/search?s=${val}`)
            .then(response => {
                // Use a Map to store unique results with URL as key
                const uniqueResults = new Map();

                if (response.data.length > 0) {
                    response.data.forEach(el => {
                        // Use URL as key to ensure uniqueness
                        if (!uniqueResults.has(el.url)) {
                            uniqueResults.set(el.url, el);
                        }
                    });

                    // Clear previous results
                    searchResults.innerHTML = '';

                    // Add unique results
                    uniqueResults.forEach(el => {
                        let result = document.createElement('li');
                        result.setAttribute('class', 'c-site-search__results__item');
                        result.innerHTML = `<a href="${el.url}">${el.title}</a>`;
                        searchResults.appendChild(result);
                    });
                    
                    // Only add 'is-open' class if we have unique results
                    if (uniqueResults.size > 0) {
                        searchResults.classList.add('is-open');
                    } else {
                        searchResults.innerHTML = '';
                        searchResults.classList.remove('is-open');
                    }
                }
                else {
                    searchResults.innerHTML = '';
                    searchResults.classList.remove('is-open');
                }

                // Hide loader
                searchInput.classList.remove('is-loading');
            })
            .catch(error => {
                console.log(error);
                // Hide loader in case of error
                searchInput.classList.remove('is-loading');
                
                // Ensure last search query can be retried
                this._lastSearchQuery = '';
            });
    }
}